import { Common } from './common';
import { ImportValidation } from './models/provider';
import { EhrInformation, ImportRow } from './models/ehrInformation';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findOneById(id: string): Promise<EhrInformation> {
    const url = this.common.constructPath(`/ehr-information/${id}`);
    return this.common.getJSON(url);
  }

  async equivalentById(
    id: string,
  ): Promise<{ ehrInformation: EhrInformation; equivalent: EhrInformation[] }> {
    const url = this.common.constructPath(`/ehr-information/${id}/equivalent`);
    return this.common.getJSON(url);
  }

  async import(args: {
    practiceId: string;
    importRows: ImportRow[];
  }): Promise<EhrInformation[]> {
    const url = this.common.constructPath(`/ehr-information/import`);
    return this.common.postJSON(url, args);
  }

  async importVerify(args: {
    practiceId: string;
    importRows: Record<string, string>[];
  }): Promise<Record<string, ImportValidation>[]> {
    const url = this.common.constructPath(`/ehr-information/import/verify`);
    return this.common.postJSON(url, args);
  }

  async update(id: string, values: { practiceId: string }) {
    const url = this.common.constructPath(`/ehr-information/${id}`);
    return this.common.patchJSON(url, values);
  }
}
